import React from "react"

type PageHeaderProps = {
  title: React.ReactNode
  subtitle?: React.ReactNode
  icon?: React.ReactNode
  /** Beside the title, e.g. a date range or a status badge. */
  meta?: React.ReactNode
  actions?: React.ReactNode
}

export function PageHeader({ title, subtitle, icon, meta, actions }: PageHeaderProps) {
  return (
    <div className="flex flex-shrink-0 items-center justify-between gap-4 border-b border-palette-jungleGreen200 bg-white px-6 py-3">
      <div className="flex min-w-0 items-center gap-3">
        {icon}
        <div>
          <h2 className="text-lg font-semibold text-palette-jungleGreen900">{title}</h2>
          {subtitle && <p className="text-sm text-palette-jungleGreen500">{subtitle}</p>}
        </div>
        {meta}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  )
}
